<script>
  import { MultiSelect } from "carbon-components-svelte";
  import ContentSwitcher from "lib/components/ContentSwitcher.svelte";
  import { Select } from "paxray-components-svelte";

  export let selectedLevel = 0;
  export let selectedShow = "";
  export let selectedApplications = [];
  export let selectedSort = "";
  export let selectedPageSize = "10";
  export let showOptions = [];
  export let applicationOptions = [];
  export let applicationLabel = "All";
  export let sortOptions = [];
  export let pageSizeOptions = [];

  // Apps filter markup is temporarily commented out; keep its props referenced.
  $: void (selectedApplications, applicationOptions, applicationLabel);
</script>

<div class="review-controls">
  <div class="control-field level-field">
    <span>Level</span>
    <ContentSwitcher
      options={["Masks", "Elements"]}
      bind:selected={selectedLevel}
      fitContent
    />
  </div>
  <div class="control-field show-field">
    <Select
      items={showOptions}
      fitContent
      placeholder="All"
      bind:selected={selectedShow}
      color="dark"
      labelText="Show"
    />
  </div>
  <!--
  <div class="control-field app-field">
    <span>Apps</span>
    {#key applicationOptions.map((option) => option.id).join("|")}
      <MultiSelect items={applicationOptions} bind:selectedIds={selectedApplications} label={applicationLabel} useTitleInItem hideLabel />
    {/key}
  </div>
  -->
  <div class="control-field sort-field">
    <Select
      items={sortOptions}
      fitContent
      bind:selected={selectedSort}
      color="dark"
      labelText="Sort by"
    />
  </div>
  <div class="control-field page-field">
    <Select
      items={pageSizeOptions}
      fitContent
      bind:selected={selectedPageSize}
      color="dark"
      labelText="Page Items"
    />
  </div>
</div>

<style>
  .review-controls {
    display: contents;
  }
  .control-field {
    display: flex;
    width: max-content;
    flex-direction: column;
    gap: 0.2rem;
    font-size: 0.75rem;
  }
  .level-field {
    gap: 0;
    min-width: 9.3rem;
  }
  .show-field {
    min-width: 8.25rem;
  }
  .sort-field {
    min-width: 6.25rem;
  }
  .page-field {
    min-width: 5rem;
  }
  /* Same height as the selects next to it, label line height like their labels. */
  .level-field > span {
    line-height: 1rem;
  }
  .control-field :global(.grid_container) {
    height: 2.5rem;
    padding: 0 0.2rem;
  }
  .control-field :global(.grid_item) {
    height: 2.1rem;
    padding: 0 0.8rem;
  }
  .control-field :global(.custom_select) {
    width: 100% !important;
    min-width: 100%;
  }
</style>
